// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pxOk","col":"styles_col__15QhT"};